/* eslint-disable max-lines */
import React, { useEffect, useState, useCallback } from "react";
import { Form } from "antd";
import { connect, useSelector } from "react-redux";

import styles from "./adFormPage.scss";
import ReactGA from "react-ga4";
import {
  submitFormData,
  getModuleContext,
  handleAdFormLayoutMobile
} from "../../HOCs";
import {
  updateAd,
  getControls,
  selectControls,
  getAdData,
  setAdData,
  selectAdData,
  clearAdData,
  applyModelSuggestedValues,
  clearAdControls
} from "../../routes/AdForm/adForm.ducks";
import {
  isObject,
  notification,
  checkEmptyObject,
  localStorage,
} from "../../services";
import history from "../../history";
import {
  PageRoute,
  LocalStorageKey,
} from "../../models";
import { selectCategories, selectModules } from "../App/selectors";
import confirmModal from "../../services/confirmModal";
import GroupPage from "./GroupPage";
import usePrevious from "../../utils/usePrevious";
import {
  selectUserInfo,
  updateUserProfile,
  getUserProfile
} from "../../routes/Auth/auth.ducks";
import { requireUserLogin } from "../../routes/Auth";
import { mapCategoryToHr, mapModuleToHr } from "../../routes/LanguageMapper";
//import { filterConditions } from "../../utils/filterMultiLevelFields";
import { UserRole } from "../../models";
import { Loading } from "../../components/Loading";
import utilsStyles from "./../../styles/utils.scss";
import { useFormFieldConditions, filterEnabledFormData } from "../../hooks/useFormFieldConditions";
import { NoImagesModal } from "./NoImagesModal";

const getFormData = values => {
  let formData = {};
  const localData = localStorage.getItem(LocalStorageKey.savedForm);

  isObject(values) &&
    Object.keys(values).forEach(key => {
      if (isObject(values[key])) {
        if (JSON.stringify(localData) != JSON.stringify(values.draftedData)) {
          formData = {
            ...localData,
            ...formData,
          };
        } else {
          formData = { ...formData, ...values[key] };
        }

      }
    });

  return formData;
};

let goingBack = false;

const showErrorOnFetch = () => {
  const actionButton = {
    text: "Moji oglasi",
    onClick: () => history.replace(PageRoute.myAd)
  };

  notification.showErrorWithAction(
    "Nije moguće učitati detalje oglasa",
    actionButton
  );
};

const AdFormPage = props => {
  const {
    form,
    module,
    controls: steps,
    match,
    adData,
    clearAdControls,
    clearAdData
  } = props;
  let headerTitle = undefined;
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [initSavedData, setInitSavedData] = useState(undefined);
  const [isValidating, setIsValidating] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [isAdWithoutImages, setIsAdWithoutImages] = useState(false);
  const [isNoImagesModalShown, setIsNoImagesModalShown] = useState(false);

  const userData = useSelector(selectUserInfo);

  // Get current form data for condition evaluation
  const currentFormData = localStorage.getItem(LocalStorageKey.savedForm) || {};

  // Use the condition hook to determine field states
  const fieldConditions = useFormFieldConditions(steps || [], currentFormData);

  const prevModule = usePrevious(module);

  const unchangableAdModules = ["userInfo", "category", "module", "phoneIds"];

  useEffect(() => {
    const { match } = props;
    const adIdParam = match.params.id;

    goingBack = false;
    if (adIdParam && !checkEmptyObject(adData)) {
      props.getAdData(adIdParam, showErrorOnFetch);
    } else {
      const paths = match.path.split("/");
      setSelectedCategory(paths[paths.length - 1]);
      setHeaderTitle(); //TODO: Davor - check if this is needed, commented out because it was causing a bug and it's not used anywhere

      handleLocalDraftData();
    }

    return () => {
      const {
        history: {
          location: { pathname, state }
        }
      } = props;

      if (match.params.id) {
        localStorage.removeItem(LocalStorageKey.savedForm);
      }
      clearAdControls();
      if (!state || (state && !state.skipAsking)) {
        clearAdData();
      }
    };
  }, []);

  const handleLocalDraftData = () => {
    const adData = localStorage.getItem(LocalStorageKey.savedForm);

    if (!checkEmptyObject(adData)) {
      return history.replace(PageRoute.myAd);
    }

    if (adData.module && adData.category) {
      props.getControls(
        mapModuleToHr(adData.module),
        mapCategoryToHr(adData.category, adData.module),
        [],
        adData,
        !match.params.id && userData
      );
    }
  };

  useEffect(() => {
    let unblock = null;

    // Check if the form is dirty and not submitting and then block routing until user confirms
    if (isDirty && !isValidating) {
      unblock = history.block((location) => {
        showUnsavedChangesModal(location);
        return false; // Block navigation until user confirms
      });
    }

    return () => {
      if (unblock) {
        unblock();
      }
    };

  }, [isDirty, isValidating]);

  // Unsaved changes confirmation modal
  const showUnsavedChangesModal = (location) => {
    confirmModal.show({
      title: "Jeste li sigurni da želite napustiti ovu stranicu?",
      okText: "Napusti bez spremanja",
      cancelText: "Odustani",
      onCancel: () => {
        return
      },
      onOk: () => {
        history.block(() => { }); // Unblock 
        history.push(location.pathname); // Proceed with navigation
      },
      children: (
        <React.Fragment>
          <p>{"Niste snimili promjene. Ako sada napustite stranicu, svi uneseni podaci bit će izgubljeni. Želite li nastaviti?"}</p>
        </React.Fragment>
      ),
    });

  };

  // When user change the field value and it's an Edit Page
  const [initialFormValues, setInitialFormValues] = useState(null);

  useEffect(() => {
    if (adData && Object.keys(adData).length > 0 && !initialFormValues) {
      // Store initial form values once data is loaded
      setInitialFormValues(adData);
    }
  }, [adData]);

  useEffect(() => {
    if (!isDirty && match.path.includes(PageRoute.editAd) && initialFormValues) {
      // Compare current form values with initial values
      for (const [key, value] of Object.entries(adData)) {
        if (JSON.stringify(value) !== JSON.stringify(initialFormValues[key])
          && !unchangableAdModules.includes(key)) {
          setIsDirty(true);
          //console.log('changed', key, value, initialFormValues[key]);
          break;
        }
      }
    }
  }, [JSON.stringify(adData), initialFormValues]);



  useEffect(() => {
    const { adData, match, module } = props;
    const adIdParam = match.params.id;

    setSelectedCategory(adData && adData.category);

    if (adData == null) {
      const adData = localStorage.getItem(LocalStorageKey.savedForm);
      adData && props.setAdData(adData);
    }

    if (steps == null && adData) {
      props.getControls(
        mapModuleToHr(adData.module),
        mapCategoryToHr(adData.category, adData.module),
        [],
        adData,
        !adIdParam && userData
      );
    }

    // Only when module is changed
    if (module != prevModule && prevModule) {
      props.setAdData(initSavedData);
      setInitSavedData(undefined);
    }

    // handle when switch between PostAd and EditAd
    if (adIdParam) {
      if (adIdParam) {
        if (!adData) {
          props.getAdData(adIdParam, showErrorOnFetch);
        }
        if (adData) {
          if (!localStorage.getItem(LocalStorageKey.savedForm)) {
            localStorage.setItem(LocalStorageKey.savedForm, adData);
          }
          if (!steps) {
            props.getControls(
              mapModuleToHr(adData.module),
              mapCategoryToHr(adData.category, adData.module),
              [],
              adData,
              !adIdParam && userData
            );
          }
        }
      } else {
        setSelectedCategory(null);
        props.clearAdData();
      }

    }

  }, [module, match.params.id, adData != null, JSON.stringify(adData)]);

  //TODO: Davor - check if this is needed, commented out because it was causing a bug and it's not used anywhere
  const setHeaderTitle = () => {
    const { module, modules, categories } = props;

    const moduleName = modules.find(m => m.route === module).displayName;
    const category = categories.find(
      c => c.moduleRoute === module && c.route === selectedCategory
    );
    headerTitle = "Novi oglas - {0}".replace(
      "{0}",
      `${moduleName} - ${category && category.displayName}`
    );
  };

  const handleSubmitProceeded = () => {
    setIsValidating(prev => !prev);
    const savedForm = localStorage.getItem(LocalStorageKey.savedForm) || {};

    if (savedForm) {
      form.validateFields((error, values) => {
        setIsValidating(prev => !prev);

        if (
          userData.role === UserRole.admin ||
          userData.role === UserRole.superAdmin
        ) {
          !error ? handlePostAd() : confirmInvalidPostAd(handlePostAd);
        } else {
          if (!error) {
            handlePostAd();
          } else {
            setTimeout(() => {
              const formItemControlWithError = document.getElementsByClassName("ant-form-item-control has-error");
              if (formItemControlWithError && formItemControlWithError.length > 0) {
                formItemControlWithError[0].scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                });
              }
            }, 500);
          }
        }
      });
    }
  }

  const handleSubmit = event => {
    event.preventDefault();
    let hasImage = false;

    // iterate through form fields and check if images has images
    // adData doesnt always have present images
    for (const [key, value] of Object.entries(form.getFieldsValue())) {
      if (
        typeof value === 'object' && (
          (value.images && value.images.length > 0) ||
          (value.floorPlans && value.floorPlans.length > 0))
      ) {
        hasImage = true;
        break;
      }
    };

    if (hasImage || isAdWithoutImages) {
      handleSubmitProceeded()
    }
    else {
      // if ad has no images, show modal
      ReactGA.event({
        category: "form warning",
        action: "popup shown",
        label: "Oglas bez slika – upozorenje prikazano"
      });

      setIsNoImagesModalShown(true)
    }

  }

  const confirmInvalidPostAd = useCallback((cb) => {
    confirmModal.show({
      title: "Molimo potvrdite",
      okText: "Potvrđujem",
      cancelText: "Odustajem",
      onCancel: () => { },
      onOk: async () => {
        await cb();
      },
      children: (
        <React.Fragment>
          <p>{"Potvrdite da želite sačuvat oglas s nevažećim ili nepotpunim podacima."}</p>
        </React.Fragment>
      )
    })
  }, []);

  // Handle Ad Form submit and determine if it is update to add ID and CODE
  const handlePostAd = async () => {
    setIsValidating(true);
    const { onSubmit, adData, match } = props;
    const adIdParam = match.params.id;

    // Filter out disabled fields from form data before submission
    const filteredFormData = filterEnabledFormData(adData, fieldConditions);
    const data: any = { formData: filteredFormData };

    if (adIdParam) {
      if (adData) {
        data.adId = adData.id;
        data.adCode = adData.code;
      }
    }


    await props.updateAd({
      formData: filteredFormData,
      adId: adData.id ? adData.id : null,
      adCode: adData.code ? adData.code : null,
      user: userData,
    }, (result: boolean) => {
      if (result) {
        props.clearAdControls();
      }
    });
    setIsValidating(false);
  };

  const goBack = () => {
    goingBack = true;
    history.goBack();
  };

  const handleSaveAndExit = () => {
    confirmModal.show({
      title: "Spremiti oglas za kasnije?",
      okText: "Spremi i izađi",
      cancelText: "Nastavi uređivati",
      onCancel: () => { },
      onOk: () => {
        history.block(() => { });
        history.push(PageRoute.home);
      },
      children: (
        <React.Fragment>
          <p>Oglas ćemo spremiti kao skicu kako biste ga mogli dovršiti i objaviti kasnije.</p>
          <p>Kada želite nastaviti, ponovno otvorite predaju oglasa. Vaša spremljena skica će vas tamo čekati - samo odaberite da želite dovršiti prethodni oglas.</p>
        </React.Fragment>
      ),
    });
  };

  return (
    <React.Fragment>
      <div className={styles.adFormPage}>
        {steps && steps.length > 0 ? (
          <GroupPage
            form={form}
            controls={props.controls}
            match={match}
            // headerTitle={step.name}
            // stepIndex={index}
            // groupName={group.name}
            handleSubmit={handleSubmit}
            handleSaveAndExit={handleSaveAndExit}
            goBack={goBack}
            isValidating={isValidating}
            setIsValidating={setIsValidating}
            isUpdate={!!match.params.id}
            fieldConditions={fieldConditions}
          />
        ) : <Loading className={`${utilsStyles.PT20} ${utilsStyles.PB20}`} />}
      </div>
      <NoImagesModal
        isNoImagesModalShown={isNoImagesModalShown}
        setIsNoImagesModalShown={setIsNoImagesModalShown}
        isValidating={isValidating}
        setIsAdWithoutImages={setIsAdWithoutImages}
        handleSubmitProceeded={handleSubmitProceeded}
      />
    </React.Fragment>
  );
};

const ConnectedAdFormPage = connect(
  state => ({
    controls: selectControls(state),
    adData: selectAdData(state),
    modules: selectModules(state),
    categories: selectCategories(state)
  }),
  {
    getControls,
    getAdData,
    setAdData,
    clearAdData,
    applyModelSuggestedValues,
    clearAdControls,
    updateUserProfile,
    getUserProfile,
    updateAd,
  }
)(
  Form.create({
    // @ts-ignore
    onValuesChange: (props, changedValue, allValues) => {
      if (!changedValue) {
        return;
      }

      let draftedData = localStorage.getItem(LocalStorageKey.savedForm);
      const updateDraft = { title: draftedData.title, draftedData, ...allValues };
      const newData = getFormData(updateDraft);

      props.setAdData(newData);

      localStorage.setItem(LocalStorageKey.savedForm, newData);
    },
  })(requireUserLogin(AdFormPage))
);

ConnectedAdFormPage.defaultProps = {
  controls: [],
  adData: {},
  loading: false
};

export default submitFormData(
  getModuleContext(handleAdFormLayoutMobile(ConnectedAdFormPage)),
  updateAd
);



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/index.tsx